export const dnldRCSErrorCodeSummary = (builder) => ({
    dnldRCSErrorCodeSummary: builder.mutation({
        query: ({ loggedin_user_id, user_type_id, code, search, startDate, endDate }) => {
            return {
                url: process.env.REACT_APP_RCS_API_PORT + '/download_rcs_error_code_summary',
                method: 'GET',
                params: { loggedin_user_id, user_type_id, code, search, startDate, endDate  },
                headers: {
                    'Content-Type': 'text/csv',
                  },
                  responseHandler: (response)=>response.blob(),
            };
        },
    }),
});